/**
 * LoginForm - Main entry point
 *
 * Uses the "Documentary Editorial" design aesthetic
 * to match the redesigned landing page.
 */

import LoginFormRedesign from './LoginFormRedesign';

export default LoginFormRedesign;
